export default function HeroSection() {
  return (
    <div className="w-full flex px-40 py-20 bg-[#FFF8F6] gap-32">
      <div className="flex flex-col gap-4 w-1/2 mt-10" data-aos="fade-right">
        <div className="px-4 bg-[#FFDAD4] text-[#B70100] w-max rounded-full font-semibold text-sm">
          <span>EST. 2021</span>
        </div>
        <h1 className="font-bold text-5xl w-4/5">
          Elevating the Way the World Learns{" "}
          <span className="text-[#B70100]">Indonesian.</span>
        </h1>
        <p className="text-wrap justify-start">
          Fluenesia was founded on a simple conviction: Indonesian is more than
          a language to be studied. It is a means of understanding a diverse
          culture and engaging with a country of growing global significance. We
          bridge the gap between conventional instruction and authentic
          communication, helping learners develop the confidence and fluency to
          use Indonesian naturally in real-world settings.
        </p>
        <div className="flex items-center gap-3">
          <span className="flex items-center -space-x-2" aria-hidden="true">
            <img
              src="/1.png"
              alt="Learner 1"
              className="w-8 h-8 rounded-full border-2 border-[#FFF8F6] bg-[#E5E7EB] box-content object-cover object-[10%_2%]"
            />
            <img
              src="/4.png"
              alt="Learner 2"
              className="w-8 h-8 rounded-full border-2 border-[#FFF8F6] bg-[#E5E7EB] box-content object-cover object-[10%]"
            />
            <img
              src="/3.png"
              alt="Learner 3"
              className="w-8 h-8 rounded-full border-2 border-[#FFF8F6] bg-[#E5E7EB] object-cover box-content object-[10%_1%_4%]"
            />
          </span>
          <span className="text-sm font-semibold text-[#2A1613]">
            5,000+ <span className="text-[#5F3F3A]">Learners Worldwide</span>
          </span>
        </div>
      </div>

      <div className="flex flex-col w-2/5" data-aos="fade-left">
        {/* <div className="flex bg-[#b6c2b5]  rounded-3xl py-24 px-4 z-10"> */}
        <img
          src="/About Us/hero.png"
          alt="discussion image"
          className="box-content shadow-2xl z-10 rounded-3xl"
        />
        {/* </div> */}
        <div className="blur-3xl bg-[#E60000] rounded-full w-32 h-32 -mt-28"></div>
      </div>
    </div>
  );
}
